import React from 'react';
import { ReferenceInput, SelectInput, ReferenceArrayInput, SelectArrayInput } from 'react-admin';
import { useForm } from 'react-final-form';

export default (props) => {
  const { formData, getSource, scopedFormData, errors, validate, ...rest } = props;
  const { id } = rest;
  var currentId = id.substring(
    id.lastIndexOf("[") + 1, 
    id.lastIndexOf("]")
  );
  const form = useForm();
  return (
    <>
      <ReferenceInput
        label="Category"
        source={getSource('id')}
        reference="categories"
        filter={{ parent_id: null }}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={() => {
          return form.change(getSource('subcategories'), []);
        }}
        perPage={100}
        fullWidth
      >
        <SelectInput
          optionText="name"
          helperText={errors.source}
          validate={validate}
        />
      </ReferenceInput>
      <ReferenceArrayInput
        label="SubCategories"
        source={getSource('subcategories')}
        resource="categories"
        reference="categories"
        filter={{ parent_id: formData.categories[currentId] && formData.categories[currentId].id }}
        sort={{ field: 'name', order: 'ASC' }}
        perPage={100}
        disabled={!(formData.categories[currentId] && formData.categories[currentId].id)}
        fullWidth
      >
        <SelectArrayInput
          optionText="name"
          helperText={errors.source}
          validate={validate}
        />
      </ReferenceArrayInput>
    </>
  );
}
